import { render, staticRenderFns } from "./CookieBar.vue?vue&type=template&id=1f0b3e17&scoped=true&"
import script from "./CookieBar.vue?vue&type=script&lang=js&"
export * from "./CookieBar.vue?vue&type=script&lang=js&"
import style0 from "./CookieBar.vue?vue&type=style&index=0&id=1f0b3e17&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f0b3e17",
  null
  
)

export default component.exports